import { App, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMCountCategoriesCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { getDropdownCount } from "../../../utils/dropdown-options";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getProjectName } from "../../../utils/get-plural-of-project-name";
import { isFieldEnabled } from "../../field-enabled";
import { makeGetCardCopy } from "../card-copy";

/** Adds the status-counts card (#2222). */
export function addCountStatusCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const countStatusComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countStatusComponent",
      labels: ["status", "count"],
      description: getCardCopy(language, "reportItemStatusCounts").description,
      title: getCardCopy(language, "reportItemStatusCounts").title,
    },
  });

  countStatusComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "countStatusComponent",
      labels: ["status", "count"],
      title: getCardCopy(language, "reportItemStatusCounts").title,
      description: getCardCopy(language, "reportItemStatusCounts").description,
    };
  });

  countStatusComponent.mapState(({ currentReport, settings }) => {
    const statusDefinition = settings?.configuration?.statusDefinition ?? [];
    const statusCounts = Object.entries(
      currentReport?.project?._calculated?.statusCounts ?? {}
    );
    const data = statusDefinition.map((entry) => ({
      label: entry.name,
      count: getDropdownCount(Object.fromEntries(statusCounts), entry),
      color: entry.color ?? "#000000",
    }));

    return {
      title: getLocalizedCardCopy(language, "reportItemStatusCounts", {
        itemName: getItemName(settings?.configuration?.itemName, language),
        itemNamePlural: getPluralOfItemName(
          settings?.configuration?.itemName,
          language
        ),
        projectName: getProjectName(
          settings?.configuration?.projectName,
          language
        ),
      }).title,

      data,
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  countStatusComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "status", "itemReporting")
  );
}
